var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIconBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 9.5,
    stroke: "#CFD1D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5026 14.75H28.5026C29.4193 14.75 30.1693 15.5 30.1693 16.4167V18.25C30.1693 18.9167 29.7526 19.75 29.3359 20.1667L25.7526 23.3333C25.2526 23.75 24.9193 24.5833 24.9193 25.25V28.8333C24.9193 29.3333 24.5859 30 24.1693 30.25L23.0026 31C21.9193 31.6667 20.4193 30.9167 20.4193 29.5833V25.1667C20.4193 24.5833 20.0859 23.8333 19.7526 23.4167L16.5859 20.0833C16.1693 19.6667 15.8359 18.9167 15.8359 18.4167V16.5C15.8359 15.5 16.5859 14.75 17.5026 14.75Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1083 14.75L18 21.3333",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconBox);
export default __webpack_public_path__ + "static/media/Filter Icon Box.2aaf913ab2be2d92362ba9aa972c1eec.svg";
export { ForwardRef as ReactComponent };